// @mui
import { styled } from "@mui/material/styles";
import { Card, CardHeader, Typography, Stack, StackProps, Divider, Box, Chip } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
// components
import Scrollbar from "../../scrollbar";
import { Top5WordsChartPropsType, Top5WordsDataType } from "src/types/types";

// ----------------------------------------------------------------------

type ItemProps = {
  id: string;
  text: string;
  value: number;
};

export default function Top5Words({ content, title, clickable }: Top5WordsChartPropsType) {
  return (
    <Stack spacing={1} sx={{ p: 3 }}>
      <Scrollbar sx={{ height: 300 }}>
        {content?.map((country: any, index: number) => {
          return <WordItem key={index} word={country} index={index + 1} clickable={clickable} />;
        })}
      </Scrollbar>
    </Stack>
  );
}

// ----------------------------------------------------------------------

type WordItemProps = {
  word: ItemProps;
  index: number;
  clickable: Top5WordsChartPropsType["clickable"];
};

function WordItem({ word, index, clickable }: WordItemProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      borderRadius={12}
      sx={{
        border: "1px dashed rgba(145, 158, 171, 0.16)",
        pr: 1.5,
        backgroundColor: word.text === clickable?.selectedWord ? "primary.lighter" : "transparent",
        cursor: "pointer",
      }}
      onClick={() => clickable?.onWordClick?.(word.text)}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          padding={1}
          px={2}
          sx={{
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12,
            bgcolor: "primary.lighter",
            width: 40,
          }}
        >
          <Typography variant="subtitle2" color="primary.dark">
            {index}
          </Typography>
        </Box>
        <Typography variant="subtitle2">{word.text}</Typography>
      </Stack>
      <Chip label={word.value} color="info" size="small" variant="soft" />
    </Stack>
  );
}
